import { useEffect } from 'react';
import { ROLE_ADMIN, ROLE_FARMER, ROLE_SUPER_ADMIN, ROLE_TECHNICIAN } from 'utils/const';

const useFilteredCulturesLocalStorage = (
  user,
  from,
  filteredCultures,
  userMaskedCulturesIndex,
  lastSelectedRows,
  setLastSelectedRows,
  toggleVisibilityFilter,
  setToggleVisibilityFilter,
  selectedRows,
  structureId,
  sectorId,
  exploitationId,
  organicState,
  hasToggleCultureShow,
  setHasToggleCultureShow
) => {
  const updateMaskedCulturesObject = {
    ...(from === 'fromCooperative' && {
      structure: structureId,
    }),
    ...(from === 'fromSector' && { sector: sectorId }),
    ...(from === 'fromExploitation' && { exploitation: exploitationId }),
    maskedRows: lastSelectedRows,
  };

  const setFilteredCulturesLocalStorage = (array) =>
    localStorage.setItem('filteredCultures', JSON.stringify(array));

  useEffect(() => {
    setLastSelectedRows(
      filteredCultures && userMaskedCulturesIndex !== -1
        ? filteredCultures?.maskedCulturesByLevel[userMaskedCulturesIndex].maskedRows || []
        : []
    );

    if (filteredCultures && userMaskedCulturesIndex !== -1) {
      setToggleVisibilityFilter({
        ...toggleVisibilityFilter,
        [organicState]: filteredCultures?.maskedCulturesByLevel?.[userMaskedCulturesIndex]
          ?.maskedRows?.[organicState]?.length
          ? true
          : false,
      });
    }
  }, [organicState]);

  useEffect(() => {
    if (filteredCultures && userMaskedCulturesIndex !== -1 && hasToggleCultureShow) {
      if (lastSelectedRows?.[organicState]?.length) {
        if (
          !selectedRows.length &&
          filteredCultures?.maskedCulturesByLevel?.[userMaskedCulturesIndex]?.maskedRows?.[
            organicState
          ]?.length
        ) {
          filteredCultures.maskedCulturesByLevel[userMaskedCulturesIndex].maskedRows[organicState] =
            [];
          setFilteredCulturesLocalStorage(filteredCultures);
          setHasToggleCultureShow(false);
        } else if (
          filteredCultures?.maskedCulturesByLevel?.[userMaskedCulturesIndex]?.maskedRows.length ===
          0
        ) {
          setLastSelectedRows([]);
          localStorage.removeItem('filteredCultures');
        }
      }
    }
  }, [selectedRows, filteredCultures, organicState]);

  useEffect(() => {
    if (!filteredCultures || userMaskedCulturesIndex === -1) {
      return;
    }

    const maskedRows =
      filteredCultures?.maskedCulturesByLevel?.[userMaskedCulturesIndex]?.maskedRows || {};

    const updateMaskedRows = (newRows) => {
      if (filteredCultures?.maskedCulturesByLevel?.[userMaskedCulturesIndex]?.maskedRows) {
        filteredCultures.maskedCulturesByLevel[userMaskedCulturesIndex].maskedRows[organicState] =
          newRows;
        setFilteredCulturesLocalStorage(filteredCultures);
      }
    };

    if (selectedRows?.length) {
      if (toggleVisibilityFilter?.[organicState]) {
        updateMaskedRows(selectedRows);
      } else {
        if (selectedRows.length < (maskedRows[organicState]?.length || 0)) {
          setLastSelectedRows((prev) => ({
            ...prev,
            [organicState]: selectedRows,
          }));
          updateMaskedRows(selectedRows);
        }
      }
    } else if (!toggleVisibilityFilter?.[organicState]) {
      const isConventionalEmpty = !maskedRows.conventional?.length;
      const isOrganicEmpty = !maskedRows.organic?.length;

      if (isConventionalEmpty && isOrganicEmpty) {
        if (filteredCultures?.maskedCulturesByLevel?.length === 1) {
          setLastSelectedRows([]);
          localStorage.removeItem('filteredCultures');
        } else {
          filteredCultures.maskedCulturesByLevel.splice(userMaskedCulturesIndex, 1);
          setFilteredCulturesLocalStorage(filteredCultures);
          setLastSelectedRows((prev) => ({
            ...prev,
            [organicState]: selectedRows,
          }));
        }
      } else if (
        filteredCultures?.maskedRotationsByLevel?.[userMaskedCulturesIndex]?.maskedRows?.[
          organicState
        ]
      ) {
        delete filteredCultures.maskedRotationsByLevel[userMaskedCulturesIndex].maskedRows[
          organicState
        ];
        setFilteredCulturesLocalStorage(filteredCultures);
      }
    }
  }, [selectedRows, filteredCultures, toggleVisibilityFilter]);

  if (filteredCultures) {
    if (
      userMaskedCulturesIndex !== -1 &&
      lastSelectedRows?.length >
        filteredCultures?.maskedCulturesByLevel?.[userMaskedCulturesIndex]?.maskedRows?.[
          organicState
        ]?.length
    ) {
      if (filteredCultures?.maskedCulturesByLevel?.[userMaskedCulturesIndex]?.maskedRows) {
        filteredCultures.maskedCulturesByLevel[userMaskedCulturesIndex].maskedRows =
          lastSelectedRows;
      }
    } else if (userMaskedCulturesIndex === -1 && lastSelectedRows?.[organicState]?.length) {
      filteredCultures.maskedCulturesByLevel.push(updateMaskedCulturesObject);
    }
    setFilteredCulturesLocalStorage(filteredCultures);
  } else if (
    userMaskedCulturesIndex === -1 &&
    lastSelectedRows?.[organicState]?.length &&
    selectedRows.length
  ) {
    let maskedCulturesByUser = {};
    switch (user?.role) {
      case 'SUPER_ADMIN':
        maskedCulturesByUser.role = ROLE_SUPER_ADMIN;
        break;
      case 'ADMIN':
        maskedCulturesByUser.role = ROLE_ADMIN;
        break;
      case 'TECHNICIAN':
        maskedCulturesByUser.role = ROLE_TECHNICIAN;
        break;
      case 'FARMER':
        maskedCulturesByUser.role = ROLE_FARMER;
        break;
    }
    maskedCulturesByUser.maskedCulturesByLevel = [updateMaskedCulturesObject];
    setFilteredCulturesLocalStorage(maskedCulturesByUser);
  }
};

export default useFilteredCulturesLocalStorage;
